import { render } from "./GuidelinesPage.vue?vue&type=template&id=493f47a2&scoped=true"
import script from "./GuidelinesPage.vue?vue&type=script&lang=js"
export * from "./GuidelinesPage.vue?vue&type=script&lang=js"

import "./GuidelinesPage.vue?vue&type=style&index=0&id=493f47a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493f47a2"]])

export default __exports__